import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { dojoData } from '../mock';

const Hero = () => {
  const { hero } = dojoData;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80; // Fixed header height
      
      // Use getBoundingClientRect for more accurate positioning
      const rect = element.getBoundingClientRect();
      const elementPosition = window.pageYOffset + rect.top - headerHeight;
      
      window.scrollTo({
        top: Math.max(0, elementPosition), // Ensure we don't scroll to negative values
        behavior: 'smooth'
      });
    }
  };

  return (
    <section 
      id="hero" 
      className="hero-section hero-with-background"
      style={{
        backgroundImage: 'url(/images/background/background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative'
      }}
    >
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.90)',
          zIndex: 0
        }}
      ></div>
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="max-w-4xl">
          {/* Hero Content */}
          <div className="mb-8">
            <h1 className="brand-display mb-4 hero-main-title" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
              L'Aïkido à Cahors
            </h1>
            <h2 className="hero-subtitle mb-6" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
              Grandir ensemble depuis 1984
            </h2>
            <p className="body-large mb-8 max-w-2xl">
              {hero.subtitle}
            </p>
          </div>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 items-start">
            <button 
              className="btn-primary flex items-center gap-2"
              onClick={() => scrollToSection('about')}
            >
              {hero.cta}
              <ArrowRight size={20} />
            </button>
            
	  {/*<button 
              className="btn-secondary flex items-center gap-2"
              onClick={() => scrollToSection('about')}
            >
              <Play size={18} />
              Learn More
            </button>*/}
          </div>

          {/* Key Benefits */}
          <div className="mt-16 pt-8 border-t border-opacity-30"
               style={{ borderColor: 'var(--border-light)' }}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center md:text-left">
                <h3 className="heading-3 mb-2" style={{ fontSize: '1.2rem', hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
                  ART MARTIAL NON-VIOLENT
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary-light)' }}>
                  Apprenez à transformer les conflits sans violence, pour tous les âges et niveaux
                </p>
              </div>
              
              <div className="text-center md:text-left">
                <h3 className="heading-3 mb-2" style={{ fontSize: '1.2rem', hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
                  AUCUNE EXPÉRIENCE REQUISE
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary-light)' }}>
                  Commencez en toute confiance dans un cadre bienveillant
                </p>
              </div>
              
              <div className="text-center md:text-left">
                <h3 className="heading-3 mb-2" style={{ fontSize: '1.2rem', hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>
                  PLUS QU'UN SPORT
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary-light)' }}>
                  Développez confiance, coordination et bien-être dans une vraie communauté
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
